import { Component, computed, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { PreviewDevice, SurveyModel } from '@empathy/survey/base';

import { IEditorForm } from '../../models/survey-editor/editor-form.interface';

@Component({
  selector: 'empathy-end-page-preview',
  templateUrl: 'end-page-preview.component.html',
  styleUrls: ['./end-page-preview.component.scss']
})
export class EndPagePreviewComponent {
  editorForm = input.required<FormGroup<IEditorForm>>();

  readonly endPage$ = computed<{ html: string; buttonText: string }>(() => {
    const surveyModel = this.editorFormValue$() as SurveyModel;

    return {
      html: surveyModel.endPageHtml ?? '',
      buttonText: surveyModel.endButtonText ?? ''
    };
  });

  phoneDevice = PreviewDevice.Phone;

  private readonly editorFormValue$ = toSignal(
    toObservable(this.editorForm).pipe(switchMap((editorForm) => editorForm.valueChanges.pipe(startWith(editorForm.value)))),
    { initialValue: {} }
  );
}
